import { Card } from './Card'

export const EmployeeStatus = ({ active, setActive, data, isLoading, filter, onSubmitFilter }) => {
    return (
        <Card
            isLoading={isLoading}
            title='Employment Status'
            filterTitle='Filter Employee Status'
            initFilter={filter}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='py-2'>
                {/* Progress Bar */}
                <div className='relative'>
                    <div className='w-full h-3 bg-neutral-30 rounded-full overflow-hidden flex'>
                        {data?.detail?.map((item, index) => (
                            <div
                                key={item.label}
                                className={`relative group h-full transition-all duration-300 ${item.color} ${item.light}`}
                                style={{ width: `${item.percentage}%` }}
                                onMouseEnter={() => setActive(index)}
                                onMouseLeave={() => setActive(null)}
                            />
                        ))}
                    </div>

                    {/* Tooltip */}
                    {active !== null && (
                        <div
                            className='absolute -top-8 bg-neutral-80 text-white text-xs px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap capitalize'
                            style={{
                                left: `${
                                    data?.detail?.slice(0, active)?.reduce((acc, curr) => acc + curr.percentage, 0) +
                                    data?.detail[active]?.percentage / 2
                                }%`,
                                transform: 'translateX(-50%)',
                            }}
                        >
                            {data?.detail[active]?.label} • {data?.detail[active]?.count} (
                            {data?.detail[active]?.percentage}%)
                        </div>
                    )}

                    <div className='flex justify-between text-sm text-neutral-50 mt-2'>
                        <span>0%</span>
                        <span>100%</span>
                    </div>
                </div>

                {/* Total */}
                <div className='flex justify-between items-center py-4'>
                    <span className='text-neutral-500 font-medium'>Total</span>
                    <span className='text-lg font-bold text-neutral-90'>{data?.total}</span>
                </div>

                {/* Legend */}
                <div className='space-y-4'>
                    {data?.detail?.map((item) => (
                        <div key={item.label} className='flex items-center justify-between'>
                            <div className='flex w-9/12 items-center gap-3'>
                                <span className={`w-3 h-3 rounded-full ${item.color}`} />
                                <span className='capitalize text-neutral-80'>{item.label}</span>
                            </div>

                            <div className='flex w-3/12 items-center justify-between gap-1'>
                                <span className='text-neutral-80'>{item.count}</span>
                                <span className='text-neutral-50'>{item.percentage}%</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Card>
    )
}
